/**
 * 이름,문구를 한 곳에서 , 헤더,문서 제목,보고서 머리가 같은 문자열을 쓴다.
 * 이것은 수소 LCA 온실가스 산정 솔루션이다. 교육 과정은 쓰임새 중 하나이지 제품 이름이 아니다.
 */
export const BRAND = {
  NAME: "수소 LCA",
  TITLE: "수소 생산, 저장, 이송 LCA 기반 온실가스 산정",
  TAGLINE: "전과정평가 절차에 따라 수소 1 kg 의 온실가스 배출량을 산정합니다",
  ORG: "한국수소연합",
  DEVELOPER: "볼트에이아이",
} as const;
